










































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarah.vue";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import KeadaanUmum from "@/components/pemeriksaan/assesmen/KeadaanUmum.vue";
import Kesadaran from "@/components/pemeriksaan/assesmen/Kesadaran.vue";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import { userModule } from "@/store/modules/user";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";

@Component({
  components: {
    TekananDarah,
    FrekuensiNadi,
    FrekuensiNafas,
    SuhuBadan,
    SaturasiOksigen,
    KeadaanUmum,
    Kesadaran,
    TimeStamp,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class TandaVital extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  @Prop() tandaVital!: object;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  time = new Date()
    .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    .toString()
    .substr(12, 8);
  maxDate = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);

  setTd(val) {
    this.tandaVital["sistole"] = val[0];
    this.tandaVital["diastole"] = val[1];
  }
  setFrekNadi(val) {
    this.tandaVital["frekuensi_nadi"] = val;
  }
  setFrekNafas(val) {
    this.tandaVital["frekuensi_nafas"] = val;
  }
  setSuhu(val) {
    this.tandaVital["suhu_badan"] = val;
  }
  setSatOksigen(val) {
    this.tandaVital["saturasi_oksigen"] = val;
  }
  setKu(val) {
    this.tandaVital["keadaan_umum"] = val;
  }
  setKesadaran(val) {
    this.tandaVital["kesadaran"] = val;
  }
  setTime(val) {
    this.tandaVital["waktu_periksa"] = val;
  }

  get stateuser() {
    return userModule.user;
  }
  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  @Watch("tandaVital")
  changeTandaVital() {
    this.$emit("tandaVital", this.tandaVital);
  }

  mounted() {}
}
